import CandidateInterviews from './CandidateInterviews.container';

export default CandidateInterviews;
